import React, { useState } from 'react'
import { useAuth, useFetch } from '../../../../_core/hooks'
import { getRandomVerifyPhoto } from '_services/enums.service'
import { EnumVerifyPhoto } from 'types/enums.options'
import { Button } from 'primereact/button'
import { Image } from 'primereact/image';
import { confirmVerifyUpload, requestMediaUrl } from '_services/users.service'
import { uploadImageToPresignedUrl } from '_services/fetches/S3upload'
import Webcam from "react-webcam"
import MediaDeviceSelection, { MediaDevicesSelected } from '../../../../components/media-device-selection'
import useMediaDevices from '../../../../_core/hooks/useMediaDevices'
import Await from '../../../../_core/components/await'

export type ProfileVerifyProps = {
  onClose: () => void
}

const constVideoWidth = 221
const constVideoHeight = 296
const constVideoAspectRatio = constVideoHeight/constVideoWidth

export const ProfileVerify: React.FC<ProfileVerifyProps> = (props) => {
  const [_,setAuth] = useAuth()
  const [verifyPhoto, setVerifyPhoto] = useState<EnumVerifyPhoto | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [checkPermissions] = useMediaDevices('camera')
  const checkPermissionsConverted = async () => (await checkPermissions()) || null
  const [stateChecking,setChecking] = React.useState(checkPermissionsConverted)
  const [stateSelected,setSelected] = React.useState<MediaDevicesSelected>()
  const [verificationImageSource, setVerificationImageSource] = useState<string | null>(null)
  const webcamRef = React.useRef<Webcam>(null)

  const fetchVerifyPhoto = async () => {
    setVerifyPhoto((await getRandomVerifyPhoto()).data)
  }

  useFetch(
    () =>  getRandomVerifyPhoto(),
    (x) => {
      if(x != undefined)
      {
        setVerifyPhoto(x.data)
      }
    },
    []
  )

  const customBase64Uploader = async (file:string) => {
    setLoading(true)
    const blob = await (await fetch(file)).blob()

    await requestMediaUrl(
      blob.type,
      async (res) => {
        await uploadImageToPresignedUrl(res.data.url, blob)
        await confirmVerifyUpload(
          res.data.id,
          verifyPhoto?.id || '',
          async ({ token }) => {
            token && setAuth(token)
            props.onClose()
            setLoading(false)
          }
        )
      },
      () => {
        setLoading(false)
      },
    )
  }

  const capture = React.useCallback(
    () => setVerificationImageSource(webcamRef.current!.getScreenshot()),
    [webcamRef]
  )
  const videoConstraints = React.useMemo(() => {
    return stateSelected?.video ? {
      deviceId: stateSelected.video.deviceId,
      'width':screen.orientation.type.startsWith('portrait') ? constVideoHeight : constVideoWidth,
      'height':screen.orientation.type.startsWith('portrait') ? constVideoWidth : constVideoHeight,
    } : {
      'width':screen.orientation.type.startsWith('portrait') ? constVideoHeight : constVideoWidth,
      'height':screen.orientation.type.startsWith('portrait') ? constVideoWidth : constVideoHeight,
      facingMode:'user',
    }
  },[stateSelected])
  return (
  <Await
    dependency={stateChecking}
    fallback={<div className="text-center">Checking Permissions...</div>}
    intermediate="undefined"
  >{(devices) => devices === null
    ? <>
      <div className="text-center">
        <p>
          Photo Verification requires access to your camera.
        </p>
        <p>
          If you would like to continue, please grant access and click "I've Granted Access".
        </p>
        <p>
          If you have already granted access and are still seeing this message,
          <br/>
          it's possible another application is already using your camera.
        </p>
        <button type="button" className="btn btn-sm btn-primary" onClick={() => setChecking(checkPermissionsConverted())}>I've Granted Access</button>
      </div>
    </>
    : <>
    <div className="d-flex flex-column">
      <h5 className="m-0 text-center">
        To get verified copy the pose below and take a photo matching the pose, we will check to make sure the photos match.
      </h5>
      <div className="my-2 d-flex justify-content-evenly">
        <div className='flex-column d-flex align-self-end text-center'>
          <Image className="p-1" src={verifyPhoto?.photoUrl} alt="Pose Image" width="221" />
          <Button type="button" className="btn link-primary" onClick={() => fetchVerifyPhoto()}>New Pose</Button>
        </div>
        <div className="d-flex flex-column align-self-end position-relative">
           {  verificationImageSource == null ?
                    <>
                      <MediaDeviceSelection video devices={devices} value={stateSelected} onChange={setSelected} maxWidth={221}></MediaDeviceSelection>
                      <Webcam
                        onUserMedia={(stream: MediaStream) => console.log('onUserMedia',stream)}
                        onUserMediaError={(e) => console.log('onUserMediaError',e)}
                        className="d-flex flex-column align-self-end"
                        mirrored
                        audio={false}
                        height={294}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={221}
                        videoConstraints={videoConstraints}
                      />
                      <Button type="button" className="btn btn-primary" onClick={capture}>Capture photo</Button>
                    </>
                  :
                    <>
                      <Image className="p-1" src={verificationImageSource} alt="Image" width="221" />
                      <Button type="button" className="btn link-primary" onClick={() => {setVerificationImageSource(null)}}>Reset Photo</Button>
                    </>

            }
        </div>
      </div>

        <p className="m-0 text-center">
          Pictures are only used to verify you and wont be posted on your account.
          For more information on how we use, retain, and protect your personal data, please read our<br/> <a href="/privacy-policy">privacy policy</a>
        </p>
        <Button className="btn btn-primary my-2" loading={loading} disabled={!verificationImageSource} onClick={() => {customBase64Uploader(verificationImageSource || '')}}>Upload Confirm Photo</Button>

      {/* <FileUpload
        className='text-center my-2'
        chooseLabel='Upload'
        mode="basic"
        name="demo[]"
        accept="image/*"
        maxFileSize={25000000}
        uploadLabel='TDOG DOG EST'
        uploadOptions={{label:'testtestest'}}
        uploadHandler={customBase64Uploader}
        customUpload
        onSelect={(e) => {setVerificationImageSource(e)}}
      /> */}
    </div>
  </>}</Await>)
}
